import './Gallery.svelte.css.proxy.js';
/* src/components/Gallery.svelte generated by Svelte v3.32.3 */
import {
	SvelteComponent,
	append,
	attr,
	binding_callbacks,
	children,
	claim_element,
	claim_space,
	destroy_each,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	query_selector_all,
	safe_not_equal,
	space,
	toggle_class
} from "../_snowpack/pkg/svelte/internal.js";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[7] = list[i];
	return child_ctx;
}

// (73:2) {#each images as image}
function create_each_block(ctx) {
	let a;
	let img;
	let img_alt_value;
	let img_src_value;
	let t;
	let a_href_value;

	return {
		c() {
			a = element("a");
			img = element("img");
			t = space();
			this.h();
		},
		l(nodes) {
			a = claim_element(nodes, "A", { href: true, class: true });
			var a_nodes = children(a);
			img = claim_element(a_nodes, "IMG", { alt: true, src: true, class: true });
			t = claim_space(a_nodes);
			a_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(img, "alt", img_alt_value = /*getImageAlt*/ ctx[3](/*image*/ ctx[7]));
			if (img.src !== (img_src_value = /*getThumbnailPath*/ ctx[2](/*image*/ ctx[7]))) attr(img, "src", img_src_value);
			attr(img, "class", "svelte-bbqn5p");
			attr(a, "href", a_href_value = /*image*/ ctx[7]);
			attr(a, "class", "svelte-bbqn5p");
		},
		m(target, anchor) {
			insert(target, a, anchor);
			append(a, img);
			append(a, t);
		},
		p(ctx, dirty) {
			if (dirty & /*images*/ 1 && img_alt_value !== (img_alt_value = /*getImageAlt*/ ctx[3](/*image*/ ctx[7]))) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*images*/ 1 && img.src !== (img_src_value = /*getThumbnailPath*/ ctx[2](/*image*/ ctx[7]))) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*images*/ 1 && a_href_value !== (a_href_value = /*image*/ ctx[7])) {
				attr(a, "href", a_href_value);
			}
		},
		d(detaching) {
			if (detaching) detach(a);
		}
	};
}

function create_fragment(ctx) {
	let script;
	let script_src_value;
	let link;
	let t;
	let div;
	let mounted;
	let dispose;
	let each_value = /*images*/ ctx[0];
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			script = element("script");
			link = element("link");
			t = space();
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			this.h();
		},
		l(nodes) {
			const head_nodes = query_selector_all("[data-svelte=\"svelte-zf3283\"]", document.head);

			script = claim_element(head_nodes, "SCRIPT", {
				src: true,
				integrity: true,
				crossorigin: true
			});

			var script_nodes = children(script);
			script_nodes.forEach(detach);

			link = claim_element(head_nodes, "LINK", {
				rel: true,
				href: true,
				integrity: true,
				crossorigin: true
			});

			head_nodes.forEach(detach);
			t = claim_space(nodes);
			div = claim_element(nodes, "DIV", { class: true });
			var div_nodes = children(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].l(div_nodes);
			}

			div_nodes.forEach(detach);
			this.h();
		},
		h() {
			if (script.src !== (script_src_value = "https://cdnjs.cloudflare.com/ajax/libs/simplelightbox/2.2.1/simple-lightbox.min.js")) attr(script, "src", script_src_value);
			attr(script, "integrity", "sha256-XC8w+g7s6jfpD0qiG2Goj2wuZ0747UaT/E0Nf2ulmew=");
			attr(script, "crossorigin", "anonymous");
			attr(link, "rel", "stylesheet");
			attr(link, "href", "https://cdnjs.cloudflare.com/ajax/libs/simplelightbox/2.2.1/simple-lightbox.min.css");
			attr(link, "integrity", "sha256-UZP8fxAiI5/RA82wRNC5aN+ebMcpGxJCnDzlKzuIVXY=");
			attr(link, "crossorigin", "anonymous");
			attr(div, "class", "svelte-bbqn5p");
			toggle_class(div, "solo-image", /*images*/ ctx[0].length === 1);
		},
		m(target, anchor) {
			append(document.head, script);
			append(document.head, link);
			insert(target, t, anchor);
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			/*div_binding*/ ctx[6](div);

			if (!mounted) {
				dispose = listen(script, "load", /*lightBoxLoaded*/ ctx[4]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*images, getImageAlt, getThumbnailPath*/ 13) {
				each_value = /*images*/ ctx[0];
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(div, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}

			if (dirty & /*images*/ 1) {
				toggle_class(div, "solo-image", /*images*/ ctx[0].length === 1);
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			detach(script);
			detach(link);
			if (detaching) detach(t);
			if (detaching) detach(div);
			destroy_each(each_blocks, detaching);
			/*div_binding*/ ctx[6](null);
			mounted = false;
			dispose();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { images = [] } = $$props;
	let { useThumbnail = true } = $$props;

	const getThumbnailPath = image => {
		if (!useThumbnail) {
			return image;
		}

		var position = image.lastIndexOf(".");
		return [image.slice(0, position), "_thumb", image.slice(position)].join("");
	};

	const getImageAlt = image => {
		var filename = image.split("/").pop();
		return filename.slice(0, filename.lastIndexOf("."));
	};

	let wrapper;

	function lightBoxLoaded() {
		var lightbox = new SimpleLightbox(wrapper.getElementsByTagName("a"), {}); /* options */
	}

	function div_binding($$value) {
		binding_callbacks[$$value ? "unshift" : "push"](() => {
			wrapper = $$value;
			$$invalidate(1, wrapper);
		});
	}

	$$self.$$set = $$props => {
		if ("images" in $$props) $$invalidate(0, images = $$props.images);
		if ("useThumbnail" in $$props) $$invalidate(5, useThumbnail = $$props.useThumbnail);
	};

	return [
		images,
		wrapper,
		getThumbnailPath,
		getImageAlt,
		lightBoxLoaded,
		useThumbnail,
		div_binding
	];
}

class Gallery extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { images: 0, useThumbnail: 5 });
	}
}

export default Gallery;
//# sourceMappingURL=Gallery.svelte.js.map
